const getStringComparisons = (index, a, b) => {
	const matches = a.substr(0, index);

	const pre = 50 > index ? 0 : index - 50;
	return {
		index,
		matches,
		differences: {
			updated: a.substr(pre, index - pre) + '| <--------> |' + a.substr(index, 50),
			prev: b.substr(pre, index - pre) + '| <--------> |' + b.substr(index, 50),
		},
	};
};

const findDiffPosition = (updated, prev) => {
	let shorterLength = Math.min(updated.length, prev.length);

	for (let i = 0; i < shorterLength; i++) {
		if (updated[i] !== prev[i]) {
			return getStringComparisons(i, updated, prev);
		}
	}

	if (updated.length !== prev.length) {
		return getStringComparisons(shorterLength, updated, prev);
	}

	return -1;
};

export default findDiffPosition;
